<template>
    <div class="Home">
        <div class="container-fluid">
            <div class="row">
                <div class="col center-text">
                    <h1>{{ WelcomeLabel }}</h1>
                </div>
            </div>

            <!--<div class="row" style="margin-top:30px;">
                <div class="col-12">
                    <h3 class="underline center-text">Check Out These Video Tutorials!</h3>
                </div>
            </div>
            <div class="row" v-for="Group in HelpVideos">
                <div class="col-12" style="margin-top:20px;">
                    <h4>{{ Group.GroupName }}</h4>
                </div>
                <div class="col-lg-4" v-for="Topic in Group.Topics">
                    <b-card :title="Topic.Name" align="center" class="fill-row">
                        <video width="100%" height="300" controls
                            source :src="Topic.URL" type="video/mp4">
                            Your browser does not support videos
                        </video>
                    </b-card>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
    library.add(faPhoneVolume);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        created() {
 
        },
        props: [],
        data: function () {
            return {
                AppointmentsNeedingDocumentaiton: "Checking...",
                HelpVideos: [
                    {
                        GroupName: "Everyone",
                        Topics: [
                            {
                                Name: "Overview",
                                URL: "/videos/overview.mp4"
                            },
                            {
                                Name: "The Service Log",
                                URL: "/videos/servicelog.mp4"
                            },
                            {
                                Name: "Appointment Scheduling",
                                URL: "/videos/appointmentscheduling.mp4"
                            }
                        ]
                    },
                    //{
                    //    GroupName: "Facilitators",
                    //    Topics: [
                    //        {
                    //            Name: "Adding Meeting Minutes",
                    //            URL: "addingminutes"
                    //        },
                    //        {
                    //            Name: "Updating Client Info",
                    //            URL: "/videos/updatingclientinfo.mov"
                    //        },
                    //        {
                    //            Name: "Plans of Care (POCs)",
                    //            URL: "/videos/plansofcare.mov"
                    //        },
                    //        {
                    //            Name: "Measures",
                    //            URL: "/videos/measures.mov"
                    //        },
                    //        {
                    //            Name: "Discharge Summaries",
                    //            URL: "/videos/dischargesummaries.mov"
                    //        },
                    //    ]
                    //},
                    //{
                    //    GroupName: "Parent Partners and BHSs",
                    //    Topics: [
                    //        {
                    //            Name: "Completing Wrap Notes",
                    //            URL: "/videos/wrapnotes.mov"
                    //        },
                    //    ]
                    //},
                    //{
                    //    GroupName: "Clinicians",
                    //    Topics: [
                    //        {
                    //            Name: "Acuity Measurements",
                    //            URL: "/videos/acuity.mov"
                    //        },
                    //    ]
                    //},
                    //{
                    //    GroupName: "Wrap Supervisors and MH Managers",
                    //    Topics: [
                    //        {
                    //            Name: "Reviewing Documents",
                    //            URL: "/videos/reviewingdocuments.mov"
                    //        },
                    //        {
                    //            Name: "Changing Caseloads",
                    //            URL: "/videos/changingcaseloads.mov"
                    //        },
                    //    ]
                    //},
                    //{
                    //    GroupName: "Admin Assistants",
                    //    Topics: [
                    //        {
                    //            Name: "Adding a Client",
                    //            URL: "/videos/addingclients.mov"
                    //        },
                    //        {
                    //            Name: "Deleting a Client",
                    //            URL: "/videos/deletingclients.mov"
                    //        },
                    //    ]
                    //},
                ]
            };
        },
        methods: {
            GetAppointmentsNeedingDocumentation() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/ClientAppointments/GetAppointmentsNeedingDocumentation", {}, this.GetAppointmentsNeedingDocumentationSuccess, () => { }, true);
            },
            GetAppointmentsNeedingDocumentationSuccess(response) {
                this.AppointmentsNeedingDocumentaiton = response.data.data.Count;
            },
            
        },
        components: {
        },
        computed: {
            WelcomeLabel: function () {
                let name = this.$store.state.User.PrivateProfile.FirstName;
                let hour = moment().hours();
                let timeOfDay = "Hello"
                if (hour < 3) {
                    timeOfDay = "Good Evening";
                } else if (hour < 12) {
                    timeOfDay = "Good Morning";
                } else if (hour < 18) {
                    timeOfDay = "Good Afternoon";
                } else {
                    timeOfDay = "Good Evening";
                }
                return timeOfDay + " " + name + "!";
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>